const businessOrderDetailView = r =>
    require.ensure(
        [],
        () => r(require('@/page/businessOrderDetail/businessOrderDetailView')),
        'businessOrderDetailView'
    );
const BuyerBatchPayDoc = r =>
    require.ensure(
        [],
        () => r(require('@/page/businessOrderDetail/BuyerBatchPayDoc')),
        'BuyerBatchPayDoc'
    );
const propRegionalCollection = r =>
    require.ensure(
        [],
        () => r(require('@/page/businessOrderDetail/propRegionalCollection')),
        'propRegionalCollection'
    );
const myMessage = r =>
    require.ensure(
        [],
        () => r(require('@/page/businessOrderDetail/myMessage')),
        'myMessage'
    ); //消息详情

export const businessOrderDetailRouter = {
    path: '',
    name: '业务单详情',
    component: businessOrderDetailView,
    meta: {
        icon: 'complaintMge',
        right: [],
        isShowMenu: false,
        keepAlive:true,
    },
    children: [{
            path: '/buyerBatchPayDoc',
            component: BuyerBatchPayDoc,
            name: '开发建设单位批量交款',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            }
        },
        {
            path: '/propRegionalCollection',
            component: propRegionalCollection,
            name: '物业区域采集',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            }
        },
        {
            path: '/myMessage',
            component: myMessage,
            name: '消息',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            }
        }
    ]
};
export default businessOrderDetailRouter;